import { ErrorADT } from "pb.safe";

import type { Route } from "../app/routes/shared/route";
import { logger } from "../shared/logger";

/**
 * Resolves configuration tokens.
 */
export function resolveTokens(
	tokens: Partial<Route.Tokens> | undefined,
): Route.Tokens | ErrorADT<"TokensInvalid"> {
	const { authAccessToken, authRefreshToken, authIdToken } = tokens ?? {};

	if (!(authAccessToken && authRefreshToken && authIdToken)) {
		logger.error("resolve tokens: invalid tokens configuration", {
			"zeller.auth.hasAccess": !!authAccessToken,
			"zeller.auth.hasRefresh": !!authRefreshToken,
			"zeller.auth.hasId": !!authIdToken,
		});
		return ErrorADT("TokensInvalid");
	}

	return {
		authAccessToken,
		authRefreshToken,
		authIdToken,
	};
}
